export interface IFlowStatusData {
  finalisedDate: string;
  finalisedReason: string;
}

export const isFlowCompleted = (flow: IFlowStatusData): boolean =>
  !!flow.finalisedDate && flow.finalisedReason === 'Completed';

export const isFlowInProgress = (flow: IFlowStatusData): boolean =>
  !flow.finalisedDate;

export const isFlowRejected = (flow: IFlowStatusData): boolean =>
  !!flow.finalisedDate && flow.finalisedReason === 'Rejected';

export const isFlowCancelled = (flow: IFlowStatusData): boolean =>
  !!flow.finalisedDate && flow.finalisedReason === 'Withdrawn';

export const isFlowDueSoon = (
  dueDate: string,
  isOverdue: (date: string) => boolean
): boolean => Boolean(dueDate && !isOverdue(dueDate));

export const isFlowDueToday = (
  dueDate: string,
  todayDate: string,
  isOverdue: (date: string) => boolean,
  getLocalDate: (date: string) => string
): boolean =>
  Boolean(
    dueDate && !isOverdue(dueDate) && getLocalDate(dueDate) === todayDate
  );

export const getDateRangeValidationError = (
  fromDate: Date | null | undefined,
  toDate: Date | null | undefined,
  todayEnd: Date,
  maxRangeEndDate: Date | null | undefined,
  maxRangeMonths: number
): string | undefined => {
  if (!fromDate) {
    return 'From date is required';
  }
  if (!toDate) {
    return 'To date is required';
  }
  if (fromDate > toDate) {
    return 'From date must be before to date';
  }
  if (toDate > todayEnd) {
    return 'To date cannot be in the future';
  }
  if (maxRangeEndDate && toDate > maxRangeEndDate) {
    return `Date range cannot be more than ${maxRangeMonths} months`;
  }
  return undefined;
};
